export const targetDeviceTypes = ["windows", "standalone", "browser"] as const;
export type TargetDeviceType = (typeof targetDeviceTypes)[number];
export const renderModes = ["cloud", "local"] as const;
export type RenderMode = (typeof renderModes)[number];
